export default "__VITE_ASSET__DogvyZ9q__"